export const AuditTrailEntryType = {
    // SOAD
    startSoadAssessmentAmendment: "startSoadAssessmentAmendment",
    cancelSoadAssessmentAmendment: "cancelSoadAssessmentAmendment",
    deleteSoadAssessment: "deleteSoadAssessment",
    recordSoadDisclosureHarm: "recordSoadDisclosureHarm",
    // Vision Instances
    createVisionInstance: "createVisionInstance",
    deleteVisionInstance: "deleteVisionInstance",
    updateVisionInstance: "updateVisionInstance",
    // Vision Incidents
    visionShareIncident: "visionShareIncident",
    visionAcceptIncident: "visionAcceptIncident",
    visionRejectIncident: "visionRejectIncident",
    visionPreviewIncident: "visionPreviewIncident",
    visionShareCodeSuccessExchange: "visionShareCodeSuccessExchange",
    visionShareCodeFailureExchange: "visionShareCodeFailureExchange",
    visionPoliceEndIncident: "visionPoliceEndIncident",
    // Vision police presence
    visionRequestPolicePresence: "visionRequestPolicePresence",
    visionRequestPolicePresenceV2: "visionRequestPolicePresenceV2",
    visionResponsePolicePresence: "visionResponsePolicePresence",
    visionPoliceAcceptRequestToStay: "visionPoliceAcceptRequestToStay",
    visionPoliceDeclineRequestToStay: "visionPoliceDeclineRequestToStay",
    // Capacity / MCA
    viewCareHomeRegister: "viewCareHomeRegister",
    addCareHomeResident: "addCareHomeResident",
    removeCareHomeResident: "removeCareHomeResident",
    recordCapacityStatus: "recordCapacityStatus",
    // Section 132 information
    viewS132Record: "viewS132Record",
    recordS132Attempt: "recordS132Attempt",
    correctS132Attempt: "correctS132Attempt",
    withdrawS132Attempt: "withdrawS132Attempt",
    // Patient
    getPatient: "getPatient",
    getPatientTimeline: "getPatientTimeline",
    createPatient: "createPatient",
    updatePatient: "updatePatient",
    synchronisePatientWithPds: "synchronisePatientWithPds",
    searchPatientIndexes: "searchPatientIndexes",
    viewPatientList: "viewPatientList",
    addPatientToPatientList: "addPatientToPatientList",
    removePatientFromPatientList: "removePatientFromPatientList",
    mergePatient: "mergePatient",
    unmergePatient: "unmergePatient",
    createExternalPatientLink: "createExternalPatientLink",
    createPatientDemographicsPullEvent: "createPatientDemographicsPullEvent",
    updatePatientDemographicsPullEvent: "updatePatientDemographicsPullEvent",
    updatePatientStateWithManualEvent: "updatePatientStateWithManualEvent",
    updatePatientStateHospitalManual: "updatePatientStateHospitalManual",
    manuallyOverridePatientStateExpiryDate: "manuallyOverridePatientStateExpiryDate",
    manuallyExtendPatientStateSection136: "manuallyExtendPatientStateSection136",
    manuallyClearPatientStateSection136Extension: "manuallyClearPatientStateSection136Extension",
    patientSearchReasoning: "patientSearchReasoning",
    patientSearchReasoningSensitive: "patientSearchReasoningSensitive",
    adminPatientDetailsLookup: "adminPatientDetailsLookup",
    updatePatientStateAutomatically: "updatePatientStateAutomatically",
    section136ClockCorrected: "section136ClockCorrected",
    dualMhaStatusDetected: "dualMhaStatusDetected",
    coexistingMhaStatusCleared: "coexistingMhaStatusCleared",
    automaticallyExpirePatientState: "automaticallyExpirePatientState",
    bulkPatientImportRowProcessed: "bulkPatientImportRowProcessed",
    backgroundTracePatient: "backgroundTracePatient",
    adminManuallyQueueBackgroundTracePatient: "adminManuallyQueueBackgroundTracePatient",
    backgroundSyncRioEthnicity: "backgroundSyncRioEthnicity",
    // Form Draft
    createFormDraft: "createFormDraft",
    getFormDraft: "getFormDraft",
    deleteFormDraft: "deleteFormDraft",
    getFormDraftPdf: "getFormDraftPdf",
    // Patient Bulk Import
    createPatientBulkImportToken: "createPatientBulkImportToken",
    revokePatientBulkImportToken: "revokePatientBulkImportToken",
    usePatientBulkImportToken: "usePatientBulkImportToken",
    // Single Use Action Token
    createSingleUseActionToken: "createSingleUseActionToken",
    revokeSingleUseActionToken: "revokeSingleUseActionToken",
    useSingleUseActionToken: "useSingleUseActionToken",
    // Form Context
    createFormContext: "createFormContext",
    updateFormContextOfficialReferenceId: "updateFormContextOfficialReferenceId",
    updateFormContextAssessmentLocation: "updateFormContextAssessmentLocation",
    bulkFormDownload: "bulkFormDownload",
    // Form
    createForm: "createForm",
    uploadForm: "uploadForm",
    signForm: "signForm",
    claimOutcomeForm: "claimOutcomeForm",
    getFormPdf: "getFormPdf",
    deleteForm: "deleteForm",
    deleteUploadedForm: "deleteUploadedForm",
    expireForm: "expireForm",
    createFormPushEvent: "createFormPushEvent",
    // Work
    createWorkRequest: "createWorkRequest",
    createAmendRequest: "createAmendRequest",
    declineWorkRequest: "declineWorkRequest",
    acceptWorkRequest: "acceptWorkRequest",
    archiveWorkRequest: "archiveWorkRequest",
    unarchiveWorkRequest: "unarchiveWorkRequest",
    claimWorkRequest: "claimWorkRequest",
    unclaimWorkRequest: "unclaimWorkRequest",
    finaliseWorkRequest: "finaliseWorkRequest",
    unfinaliseWorkRequest: "unfinaliseWorkRequest",
    expireAmendRequest: "expireAmendRequest",
    cancelAmendRequest: "cancelAmendRequest",
    // De minimis corrections
    createDeMinimisRequest: "createDeMinimisRequest",
    acceptDeMinimisRequest: "acceptDeMinimisRequest",
    completeDeMinimisRequest: "completeDeMinimisRequest",
    rejectDeMinimisRequest: "rejectDeMinimisRequest",
    cancelDeMinimisRequest: "cancelDeMinimisRequest",
    // Redo admission forms (non-s15)
    createRedoRequest: "createRedoRequest",
    retractRedoRequest: "retractRedoRequest",
    acceptRedoRequest: "acceptRedoRequest",
    declineRedoRequest: "declineRedoRequest",
    initiateRedo: "initiateRedo",
    cancelRedoInProgress: "cancelRedoInProgress",
    completeRedo: "completeRedo",
    cancelWorkRequest: "cancelWorkRequest",
    autoRouteToMhlTeam: "autoRouteToMhlTeam",
    adminDeleteWorkItem: "adminDeleteWorkItem",
    createFileNoteRequest: "createFileNoteRequest",
    deleteFileNoteRequest: "deleteFileNoteRequest",
    adminScheduleWorkItemExpiry: "adminScheduleWorkItemExpiry",
    workItemExpiry: "workItemExpiry",
    // User
    createUser: "createUser",
    updateUserEmail: "updateUserEmail",
    deleteUser: "deleteUser",
    convertGuestUser: "convertGuestUser",
    convertFullUserToGuest: "convertFullUserToGuest",
    createIndependentContext: "createIndependentContext",
    deleteSoadContext: "deleteSoadContext",
    deleteIndependentContext: "deleteIndependentContext",
    updateUserProfile: "updateUserProfile",
    passwordResetTriggered: "passwordResetTriggered",
    resetAuthenticationMethods: "resetAuthenticationMethods",
    revokeAllDeviceSessions: "revokeAllDeviceSessions",
    revokeDeviceSession: "revokeDeviceSession",
    // Favourite recipients
    favouriteRecipientAdded: "favouriteRecipientAdded",
    favouriteRecipientRemoved: "favouriteRecipientRemoved",
    acceptTermsAndConditions: "acceptTermsAndConditions",
    // MFA
    mfaEnforced: "mfaEnforced",
    allowSmsMfa: "allowSmsMfa",
    disallowSmsMfa: "disallowSmsMfa",
    mfaDisabled: "mfaDisabled",
    resetMfa: "resetMfa",
    guestUserLoginSuccess: "guestUserLoginSuccess",
    guestUserLoginFailure: "guestUserLoginFailure",
    userLoginSuccess: "userLoginSuccess",
    userLogout: "userLogout",
    // team
    createTeam: "createTeam",
    deleteTeam: "deleteTeam",
    updateTeam: "updateTeam",
    mergeTeam: "mergeTeam",
    addUserToTeam: "addUserToTeam",
    addUserToManagingOrganisations: "addUserToManagingOrganisations",
    removeUserFromTeam: "removeUserFromTeam",
    addUserToOrganisation: "addUserToOrganisation",
    removeUserFromOrganisation: "removeUserFromOrganisation",
    // email redirects
    addEmailRedirect: "addEmailRedirect",
    removeEmailRedirect: "removeEmailRedirect",
    // admin
    setSystemToggle: "setSystemToggle",
    addApprovedEmailDomain: "addApprovedEmailDomain",
    removeApprovedEmailDomain: "removeApprovedEmailDomain",
    adminCreateTermsAndConditions: "adminCreateTermsAndConditions",
    getGuestUserCode: "getGuestUserCode",
    resetGuestUserLogins: "resetGuestUserLogins",
    adminDeleteDataPermission: "adminDeleteDataPermission",
    bulkMigrateDataPermission: "bulkMigrateDataPermission",
    deleteEmptyAdmissions: "deleteEmptyAdmissions",
    deleteEmptyAdmission: "deleteEmptyAdmission",
    scaryAdminDeletePatientMhaStatuses: "scaryAdminDeletePatientMhaStatuses",
    adminRunAutoMergeJob: "adminRunAutoMergeJob",
    // configuration
    setOrganisationConfiguration: "setOrganisationConfiguration",
    setUserOrganisationConfiguration: "setUserOrganisationConfiguration",
    // organisation
    createOrganisation: "createOrganisation",
    updateOrganisation: "updateOrganisation",
    deleteOrganisation: "deleteOrganisation",
    // organisation managing users
    addOrganisationUserForManaging: "addOrganisationUserForManaging",
    deleteOrganisationUserForManaging: "deleteOrganisationUserForManaging",
    // data sharing partnerships
    createDataSharingPartnership: "createDataSharingPartnership",
    deleteDataSharingPartnership: "deleteDataSharingPartnership",
    addDataControllerToDataSharingPartnership: "addDataControllerToDataSharingPartnership",
    removeDataControllerFromDataSharingPartnership: "removeDataControllerFromDataSharingPartnership",
    // dashboarding / reporting
    workReport: "workReport",
    patientStateReport: "patientStateReport",
    //Admissions
    recordReasonForNotProceedingMedRec: "recordReasonForNotProceedingMedRec",
    recordReasonForNotProceedingNoApp: "recordReasonForNotProceedingNoApp",
    reopenAdmission: "reopenAdmission",
    autoCloseAdmissionNoMedRec: "autoCloseAdmissionNoMedRec",
    // FHIR API (machine actor — the calling FHIR client, never a user)
    fhirDocumentSearch: "fhirDocumentSearch",
    fhirDocumentRead: "fhirDocumentRead",
    fhirEpisodeOfCareRead: "fhirEpisodeOfCareRead",
    //Rio Clickthrough
    rioClickThroughLaunch: "rioClickThroughLaunch",
    rioClickThroughLogin: "rioClickThroughLogin",
    //TPP Clickthrough
    tppClickThrough: "tppClickThrough",
    tppTokenRedeemed: "tppTokenRedeemed",
    createTppInstance: "createTppInstance",
    updateTppInstance: "updateTppInstance",
    deleteTppInstance: "deleteTppInstance",
    //Generic EPR Clickthrough
    genericClickThrough: "genericClickThrough",
    genericTokenRedeemed: "genericTokenRedeemed",
    createGenericInstance: "createGenericInstance",
    updateGenericInstance: "updateGenericInstance",
    deleteGenericInstance: "deleteGenericInstance",
    // Clickthrough remembered-login links (EPR username -> eMHA user)
    createEprUserLink: "createEprUserLink",
    deleteEprUserLink: "deleteEprUserLink",
    // merges
    createSuggestedPatientMerge: "createSuggestedPatientMerge",
    actionSuggestedPatientMerge: "actionSuggestedPatientMerge",
    // auto-update of NHS number
    patientSupersededNhsNumberUpdated: "patientSupersededNhsNumberUpdated",
    // demographics alerts
    createPatientDemographicsAlert: "createPatientDemographicsAlert",
    clearPatientDemographicsAlerts: "clearPatientDemographicsAlerts",
    // place of safety
    deletePosInstance: "deletePosInstance",
    updatePosInstance: "updatePosInstance",
    searchPos: "searchPos",
    // Mental Health Care Provider
    createMentalHealthCareProvider: "createMentalHealthCareProvider",
    deleteMentalHealthCareProvider: "deleteMentalHealthCareProvider",
    updateMentalHealthCareProvider: "updateMentalHealthCareProvider",
    searchMentalHealthCareProvider: "searchMentalHealthCareProvider",
    // London Care Record
    createLondonCareRecordInstance: "createLondonCareRecordInstance",
    deleteLondonCareRecordInstance: "deleteLondonCareRecordInstance",
    updateLondonCareRecordInstance: "updateLondonCareRecordInstance",
    bulkDeletesJobsFromDeadLetterQueue: "bulkDeletesJobsFromDeadLetterQueue",
    retryPatientJobsFromDeadLetterQueue: "retryPatientJobsFromDeadLetterQueue",
    deletePatientJobsFromDeadLetterQueue: "deletePatientJobsFromDeadLetterQueue",
    createLondonCareRecordExclusion: "createLondonCareRecordExclusion",
    removeLondonCareRecordExclusion: "removeLondonCareRecordExclusion",
    unmergeLondonCareRecordPatient: "unmergeLondonCareRecordPatient",
    // Trust
    createTrust: "createTrust",
    deleteTrust: "deleteTrust",
    updateTrust: "updateTrust",
    searchTrust: "searchTrust",
    createTrustOid: "createTrustOid",
    updateTrustOid: "updateTrustOid",
    deleteTrustOid: "deleteTrustOid",
    // NHS Dashboard
    nhsDashboardAccessed: "nhsDashboardAccessed",
    // Superset Dashboard
    supersetDashboardAccessed: "supersetDashboardAccessed",
    supersetDashboardExported: "supersetDashboardExported",
    // Section 12 Doctor Finder
    section12SpecialismCreated: "section12SpecialismCreated",
    section12SpecialismUpdated: "section12SpecialismUpdated",
    section12SpecialismDeleted: "section12SpecialismDeleted",
    section12UserAvailabilityUpdated: "section12UserAvailabilityUpdated",
    section12AvailabilityOverrideUpdated: "section12AvailabilityOverrideUpdated",
    section12AvailabilityOverrideDeleted: "section12AvailabilityOverrideDeleted",
    section12UserSpecialismsUpdated: "section12UserSpecialismsUpdated",
    section12UserLocalAuthorityMappingsUpdated: "section12UserLocalAuthorityMappingsUpdated",
    section12PhoneVerified: "section12PhoneVerified",
    section12PhoneRemoved: "section12PhoneRemoved",
    section12DoctorSearch: "section12DoctorSearch",
    section12UpdateHomeBaseLocation: "section12UpdateHomeBaseLocation",
    section12GenderUpdated: "section12GenderUpdated",
    section12LanguageCreated: "section12LanguageCreated",
    section12LanguageUpdated: "section12LanguageUpdated",
    section12UserLanguagesUpdated: "section12UserLanguagesUpdated",
    section12TrustAffiliationUpdated: "section12TrustAffiliationUpdated",
    section12MaxTravelTimeUpdated: "section12MaxTravelTimeUpdated",
    section12ContactPreferencesUpdated: "section12ContactPreferencesUpdated",
    section12ApprovalChecked: "section12ApprovalChecked",
    // Section 12 Payment Requests
    section12PaymentRequestCreated: "section12PaymentRequestCreated",
    section12PaymentRequestUpdated: "section12PaymentRequestUpdated",
    section12PaymentRequestLimitedEdit: "section12PaymentRequestLimitedEdit",
    section12PaymentRequestDeleted: "section12PaymentRequestDeleted",
    section12PaymentRequestStatusChanged: "section12PaymentRequestStatusChanged",
    section12PaymentRequestFeesAdjusted: "section12PaymentRequestFeesAdjusted",
    section12PaymentRequestLocalAuthorityChanged: "section12PaymentRequestLocalAuthorityChanged",
    section12PaymentRequestCsvExport: "section12PaymentRequestCsvExport",
    section12PaymentRequestViewed: "section12PaymentRequestViewed",
    section12PaymentRequestsListed: "section12PaymentRequestsListed",
    section12ReceiptDownloaded: "section12ReceiptDownloaded",
    section12PaymentRequestMoved: "section12PaymentRequestMoved",
    // Section 12 Phone Verification
    section12PhoneVerificationCodeSent: "section12PhoneVerificationCodeSent",
    // Section 12 Calendar Sync
    section12CalendarConnectionsListed: "section12CalendarConnectionsListed",
    section12CalendarConnected: "section12CalendarConnected",
    section12CalendarDisconnected: "section12CalendarDisconnected",
    section12CalendarSyncToggled: "section12CalendarSyncToggled",
    section12CalendarSyncTriggered: "section12CalendarSyncTriggered",
    // Hospital MHL Auto-Route Configuration
    updateHospitalMhlAutoRouteConfig: "updateHospitalMhlAutoRouteConfig",
    // Interviews
    interviewCreated: "interviewCreated",
    interviewUpdated: "interviewUpdated",
    interviewCancelled: "interviewCancelled",
    interviewParticipantAdded: "interviewParticipantAdded",
    interviewParticipantAccepted: "interviewParticipantAccepted",
    interviewParticipantRejected: "interviewParticipantRejected",
    interviewParticipantConfirmed: "interviewParticipantConfirmed",
    interviewParticipantRevoked: "interviewParticipantRevoked",
    interviewParticipantRestored: "interviewParticipantRestored",
    interviewParticipantReContacted: "interviewParticipantReContacted",
    // Xero Integration
    xeroConfigurationUpdated: "xeroConfigurationUpdated",
};
//# sourceMappingURL=AuditTrailEntryType.js.map